export default __webpack_public_path__ + "static/media/scan_EN.a0eabeef.png";